var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrmImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1830 1809.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efeff4;}.cls-2{fill:#18174a;}.cls-3{fill:#a8abb2;}.cls-4{fill:#c6c9d3;}.cls-5{fill:#2b69b3;}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:url(#linear-gradient-2);}.cls-34,.cls-8{fill:#fff;}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:#ecc538;}.cls-12{fill:#333435;}.cls-13{fill:url(#linear-gradient-5);}.cls-14{fill:url(#linear-gradient-6);}.cls-15{fill:#b9bcc5;}.cls-16{fill:#979aa0;}.cls-17{fill:#5c5e61;}.cls-18{fill:url(#linear-gradient-7);}.cls-19{fill:url(#linear-gradient-8);}.cls-20{fill:url(#linear-gradient-9);}.cls-21{fill:url(#linear-gradient-10);}.cls-22{opacity:0.87;}.cls-23{opacity:0.82;}.cls-24{fill:#d7d9e0;}.cls-25{fill:#e8e8ef;}.cls-26{fill:url(#linear-gradient-11);}.cls-27{fill:url(#linear-gradient-12);}.cls-28{fill:url(#linear-gradient-13);}.cls-29{fill:url(#linear-gradient-14);}.cls-30{fill:url(#linear-gradient-15);}.cls-31{fill:url(#linear-gradient-16);}.cls-32{fill:url(#linear-gradient-17);}.cls-33{fill:url(#linear-gradient-18);}.cls-34{opacity:0.78;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 793.58,
    y1: 1437.24,
    x2: 1050.39,
    y2: 1437.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efeff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 490.84,
    y1: 1301.29,
    x2: 600.21,
    y2: 1301.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 951.2,
    y1: 1168.79,
    x2: 534.1,
    y2: 1384.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74767b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c5e61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 166.83,
    y1: 1447.85,
    x2: 563.92,
    y2: 1447.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 788.93,
    y1: 1502.18,
    x2: 852.22,
    y2: 1502.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1361.61,
    y1: 1082.85,
    x2: 1346.12,
    y2: 1224.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1618.23,
    y1: 1540.24,
    x2: 1484.39,
    y2: 1797.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2850.96,
    y1: 4009.82,
    x2: 2702.94,
    y2: 4205.65,
    gradientTransform: "matrix(-0.69, -0.73, -0.73, 0.69, 6209.39, 330.36)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1380.61,
    y1: 1084.92,
    x2: 1365.13,
    y2: 1226.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 140.86,
    y1: 556.29,
    x2: 423.07,
    y2: 556.29,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1408.47,
    y1: 388.74,
    x2: 1821.05,
    y2: 388.74,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1234.4,
    y1: 567.84,
    x2: 1536.56,
    y2: 567.84,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 938.9,
    y1: 547.58,
    x2: 1339.01,
    y2: 547.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 701.21,
    y1: 617.52,
    x2: 1073.26,
    y2: 617.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1792.41,
    y1: 92.75,
    x2: 1800.47,
    y2: 92.75,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1605.09,
    y1: 142.62,
    x2: 1807.16,
    y2: 142.62,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1184.74,
    y1: 442.23,
    x2: 1312.81,
    y2: 442.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1159.83,
    y1: 548.88,
    x2: 1172.56,
    y2: 548.88,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1600.79,1555.71c-46.65,48.08-88.39,76.35-120.34,97.69-311.68,208.11-668,148.12-778.12,127.62-177.72-33.08-327.74-56.41-456.63-172.86C-47.19,1343.55-32.94,791.55,190.86,449.61c26.53-40.54,250-371.78,607.05-418.46,8.73-1.14,15.25-1.79,21-2.39C874.1,22.91,1216.38-8,1495.48,225.87A832.64,832.64,0,0,1,1659.35,411.8C1877.35,748.48,1878,1269.93,1600.79,1555.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1657.28,1735.49c0,15.78-12.55,28.68-27.88,28.68H122c-15.33,0-27.88-12.9-27.88-28.68l-12.54-892c0-15.77,18-46.57,51.12-44.25L1605.9,760a69.22,69.22,0,0,1,51.46,21.09A73.43,73.43,0,0,1,1678,834Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1656.91,1708a27.07,27.07,0,0,1-26.83,27.16H159.66A27.08,27.08,0,0,1,132.82,1708l-12-809.78C122.2,849.47,164.41,832,190,833l1436.73-39a49.82,49.82,0,0,1,36.79,14.82,51.11,51.11,0,0,1,14.75,37.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148.71,1321.49a2.19,2.19,0,0,1-2.17-2.16l-.95-65.67a2.17,2.17,0,1,1,4.34-.07l.95,65.68a2.17,2.17,0,0,1-2.14,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.38,1160.56a2.18,2.18,0,0,1-2.17-2.16l-3.65-251.52c.08-16.8,5.19-30.22,15.2-39.93,18.21-17.65,46.71-16.77,47.92-16.72l458.81-12.46a2.2,2.2,0,0,1,.12,4.39L203.67,854.62c-1.29-.06-28-.88-44.91,15.5C149.63,879,145,891.33,144.9,906.86l3.65,251.48a2.18,2.18,0,0,1-2.14,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.6,1663.06c1.54-66.93,1-659.61-2.83-710.79s75-60.79,195.93-66.55S1532.13,857.16,1558.41,855c59.06-4.85,71.28,84.49,65.37,278.42-4.44,145.7-11.79,385.72-15.18,496.1-1,32.86-27.55,58.94-60,59-245.56.68-1186.76,3.41-1249.42,5.3C227,1696,197,1689.6,197.6,1663.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 1731.32,
    width: 1830,
    height: 78.38,
    rx: 7.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M880,1445.53s-13.3-35-28.85-31.83-32.56,15.15-32.56,15.15l-25,33.78s70.11,27.62,94.77,11.79c0,0,71.61,12.38,162-2.46-13.09-27.64-20.89-55.31-25.47-76.79C979.12,1421.1,929.78,1440.46,880,1445.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1259.31,1191.39s-102.53,129.14-234.39,203.78c4.58,21.48,12.38,49.15,25.47,76.79,68.41-11.23,147.57-38,214.68-97.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M490.84,1208.47l6.37,171a471.67,471.67,0,0,0,51.68,14.68c10.26-33,32.83-73.53,51.32-103.65C532.29,1266.45,490.84,1208.47,490.84,1208.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M830,1205.56c-93.17,100.6-168.59,106.52-229.74,84.9-18.49,30.12-41.06,70.64-51.32,103.65C797.7,1449,856.3,1220.22,856.3,1220.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M848.84,1194.88s10.74-11.53,30.6-7.91,37.54,10.53,49.92,0,16.73,3.6,16.73,3.6L909,1218.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M826.68,1214.58s7.35-30.75,29.51-26.54,72.48,31.58,85.44,26.54,29.55-17.11,38-12.84l-15,18.63s38.52-22.22,45.15-8.57l-64.09,36.07S852,1238.48,826.68,1214.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M168.3,1729.81s-31.79-411.76,200-552.89c0,0,64.79-42.77,145.53,40.07s54.73,168.9-13,249.55S364,1649.16,380.44,1729.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M485.07,1053.3c-.06,5.41-77.23,115-77.23,115s13.85,27.29,80,49.44l57.08-117.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M454.72,1429.65s146.42,122.62,304.53,69.12a37.65,37.65,0,0,1,29.68,2.23l45.46,24A40.57,40.57,0,0,0,888.16,1510c6.32-10.56,11.71-22.63,12.78-34.18l-88.94-36,6.55-10.91s-43.42-3.68-54.79,27.45c0,0-82.71,34.4-222.2-119C541.56,1337.27,478.26,1391.09,454.72,1429.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M446.84,1429.11a3.26,3.26,0,0,1-1.81-.55c-61.83-41.78-90.92-109.21-91.21-109.89a3.24,3.24,0,0,1,6-2.53c.28.66,28.67,66.38,88.87,107a3.24,3.24,0,0,1-1.82,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M538.67,1335.93a3.26,3.26,0,0,1-2.73-1.49c-.18-.29-19-29.63-54.91-93.89-10.93-19.56-25.28-32-42.64-36.81-28.78-8.06-56.56,7.39-56.84,7.55a3.24,3.24,0,1,1-3.2-5.64c1.22-.69,30.3-16.94,61.73-8.17,19.11,5.33,34.79,18.76,46.6,39.91,35.77,64,54.52,93.26,54.71,93.54a3.25,3.25,0,0,1-2.72,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M545.83,988.24s27.46,61,29.31,93.06,9,52.82-29.31,59.27-70.53-12-88-43.91c0,0-27.38-49.16-21.24-69.3S545.83,988.24,545.83,988.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M470.91,1073.72l2.18-.93a5,5,0,0,0,2.57-7c-5.4-10.09-15.93-33.22-2.33-38.61,17.52-7,86.92-20.64,101.9-44.47,14.39-22.9,1.64-52.46-17.53-60.86a2.67,2.67,0,0,0-3.45,1.09s-28.11,20.48-61.34,26.41c-47.23,8.43-78.45,26.92-79.23,58.5a2.6,2.6,0,0,1-4,2.07c-3.49-2.05-9.07-3-16.53,3-13,10.55-7.66,37.92,20.77,60.44a2.45,2.45,0,0,1-.12,4c-5.16,3.24-12.84,11,7.07,21.26,20.59,10.66,36,9.78,41.89,8.84a2.52,2.52,0,0,0,2.11-3l-6.33-27.75a2.55,2.55,0,0,1,2.55-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M472.1,1079.58s-10.48-39-28.54-28.06,9.37,43.68,23.9,45.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M788.93,1501s37.21,36.4,44.39,31.1c2.55-1.89,9-8.73,15.25-16.36a16,16,0,0,0,1.09-18.82l-8.78-13.54a25.36,25.36,0,0,0-37.86-5.51C797.17,1483,791.86,1490.33,788.93,1501Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1375.26,1729.81s-.25-128.09-95.33-297c-29.74-52.82-40.31-114.29-31-174.19l10.42-67.28s130.47-44.15,275.11-1.86c0,0,200.54,116.92,66.51,540.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1281.52,1105.53l33.83,81.28a16.19,16.19,0,0,0,12.24,9.73c19.5,3.35,66.68,8.57,97.67-11.8a7.87,7.87,0,0,0,2.1-11.07l-62.5-89.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1365,1487.52a7.5,7.5,0,0,0-4.74,10.73l97.88,187.69a7.51,7.51,0,0,0,8.74,3.74L1787,1597.24a7.51,7.51,0,0,0,5.14-9.3L1737,1397a7.52,7.52,0,0,0-9.14-5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1385.62,1465.46a7.86,7.86,0,0,0-5.56,10.37l78.35,212.83a7.87,7.87,0,0,0,9.56,4.84l319.21-92.16a7.86,7.86,0,0,0,5.5-9.22l-44.23-204.84a7.86,7.86,0,0,0-9.51-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1413.42,1444a9.72,9.72,0,0,0-8,11.8l53.22,229.76a9.72,9.72,0,0,0,12.16,7.15l314.37-90.77a9.72,9.72,0,0,0,6.72-11.76l-48.35-187.55a9.71,9.71,0,0,0-10.87-7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1667.9,1531.6c24.4-184.32-117.64-326-117.64-326l-84.51,98.52c64.16,80,94.66,153.26,108.59,210.81C1592.82,1509.51,1637.3,1501,1667.9,1531.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1574.34,1517.06a2.17,2.17,0,0,1-2.1-1.66c-17.28-71.39-53.67-142-108.17-210a2.16,2.16,0,0,1,3.36-2.7c54.9,68.43,91.58,139.64,109,211.66a2.15,2.15,0,0,1-1.59,2.6A1.79,1.79,0,0,1,1574.34,1517.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1574.34,1514.89c13,53.5,11.59,93.41,9.62,112.47a14.85,14.85,0,0,1-13.72,13.3c-8.19.57-19.33,1.32-29.28,1.9-10.94.63-23.09-6.29-31.21-12.07a4.88,4.88,0,0,0-7.19,6.18c6.06,11.86,21.44,22.41,32,28.62a5.06,5.06,0,0,1-1.17,9.24l-45.34,12.86c74.5,70.19,123.69-8.35,123.69-8.35,32.89-50.82,49.9-100.51,56.11-147.44C1637.3,1501,1592.82,1509.51,1574.34,1514.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1316.51,981.17c-1.42,1.34-60,116.31-60,116.31l66.36,32,71.68-100.73S1340.3,958.78,1316.51,981.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1364.42,1040.87,1331.33,1096a10.5,10.5,0,0,1-1.82,2.26c-3.94,3.67-17.42,14.34-27.84-.19-8.88-12.37-17.22-23.62-26.15-28.27a10.57,10.57,0,0,0-14.27,4.71c-5.46,10.8-16,32.83-22.65,53.72a10.52,10.52,0,0,0,6.13,12.92c13.43,5.45,40,15.29,63.56,18.55a10.57,10.57,0,0,0,10-4.26c10.14-13.89,38.72-52.7,48.47-62.42,9.06-9,25.78-5.62,33.32-3.46a10.64,10.64,0,0,0,8.46-1.11c7.64-4.6,21-16.07,8.78-35.48a10.59,10.59,0,0,1,3.27-14.39c8.54-5.62,17.8-16.16,9-33.23-8.94-17.27-24.89-18.83-35.75-17.5a11,11,0,0,1-11.54-6.41,7,7,0,0,0-5.46-4.3,10.28,10.28,0,0,1-8.31-12.07c1.91-9.77.47-22.48-15.14-31.06-28.63-15.74-53.71,9.91-60.09,31.56s25.64,37,45.77,39.51c14.79,1.88,22.9,18,26.17,26.46A10.6,10.6,0,0,1,1364.42,1040.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1354.33,1113.32s12.73-37.25,29-35.88,29.12,17.6,8.92,35.85C1367.16,1136,1354.33,1113.32,1354.33,1113.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M994.78,937.91l-156.92-8.16c-14.31-.74-26.86,7.8-28.69,19.53L774,1174.41c-2.1,13.42,10.57,25.31,27,25.31h204.75c15.54,0,27.92-10.72,27.18-23.52l-12.7-217C1019.57,947.81,1008.61,938.63,994.78,937.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M971.64,960.79c2.71,0,5-1.77,5.08-4,.14-2.89,2.91-70.89-55.11-78.37-12.41-1.6-23.42.8-32.73,7.15-28.25,19.25-30.63,68.8-30.72,70.9-.1,2.31,2.1,4.25,4.9,4.33s5.16-1.73,5.26-4c0-.48,2.31-47.89,27-64.74,7.06-4.81,15.14-6.54,24.68-5.32,49.15,6.33,46.56,69.11,46.52,69.74-.11,2.31,2.07,4.26,4.87,4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M341.7,411.33H222.23a41.52,41.52,0,0,0-35.94,20.74L126.55,535.55a41.5,41.5,0,0,0,0,41.49l59.74,103.47a41.49,41.49,0,0,0,35.94,20.74H341.7a41.49,41.49,0,0,0,35.94-20.74L437.38,577a41.5,41.5,0,0,0,0-41.49L377.64,432.07A41.52,41.52,0,0,0,341.7,411.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M222.23,681.4a21.7,21.7,0,0,1-18.74-10.82L143.75,567.11a21.72,21.72,0,0,1,0-21.64L203.49,442a21.69,21.69,0,0,1,18.74-10.81H341.7A21.69,21.69,0,0,1,360.44,442l59.74,103.48a21.7,21.7,0,0,1,0,21.63L360.44,670.58A21.7,21.7,0,0,1,341.7,681.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M343.94,544.59l-4.26-16.52a1.16,1.16,0,0,0-1-.88l-14.17-1.14a61.84,61.84,0,0,0-12.07-16l2.85-13.94a1.16,1.16,0,0,0-.55-1.24L300,486.15a1.16,1.16,0,0,0-1.35.11l-10.83,9.22A62.08,62.08,0,0,0,268,492.66l-7.83-11.87a1.17,1.17,0,0,0-1.27-.48l-16.53,4.25a1.16,1.16,0,0,0-.87,1l-1.14,14.17a62.25,62.25,0,0,0-16.05,12.06L210.33,509a1.16,1.16,0,0,0-1.24.55l-8.68,14.69a1.16,1.16,0,0,0,.11,1.35l9.22,10.83a62.4,62.4,0,0,0-2.83,19.88l-11.86,7.84a1.15,1.15,0,0,0-.48,1.26l4.25,16.53a1.16,1.16,0,0,0,1,.87L214,583.93A61.81,61.81,0,0,0,226.09,600l-2.85,13.94a1.19,1.19,0,0,0,.55,1.24l14.7,8.68a1.18,1.18,0,0,0,1.35-.12l10.83-9.22a61.81,61.81,0,0,0,19.88,2.83l7.83,11.86a1.18,1.18,0,0,0,1.27.49l16.53-4.25a1.17,1.17,0,0,0,.87-1l1.14-14.17a62.06,62.06,0,0,0,16.05-12.07L328.17,601a1.18,1.18,0,0,0,1.25-.55l8.67-14.69a1.18,1.18,0,0,0-.11-1.36l-9.22-10.83a62.36,62.36,0,0,0,2.83-19.88l11.86-7.83A1.2,1.2,0,0,0,343.94,544.59Zm-59.32,2a17.5,17.5,0,1,1-23.74-7A17.52,17.52,0,0,1,284.62,546.62Zm-4.69,50.85a43.52,43.52,0,1,1-21.68-84.3c.77-.2,1.54-.37,2.31-.53h.05a44.3,44.3,0,0,1,5.83-.76l1-.05.18,4.69a39.23,39.23,0,0,0-8.18,1.21,38.53,38.53,0,0,0-22.92,16.5q-.44.66-.84,1.35a38.58,38.58,0,0,0-5.41,19.68,38.84,38.84,0,1,0,77.67.06,38.32,38.32,0,0,0-1.23-9.66,38.75,38.75,0,0,0-10.29-17.94l3.3-3.34a43.52,43.52,0,0,1-19.77,73.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M258,561.12a12.8,12.8,0,1,0,5.11-17.37A12.83,12.83,0,0,0,258,561.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M369.13,486.37l-1.4-5.46a.38.38,0,0,0-.34-.29l-4.69-.38a20.47,20.47,0,0,0-4-5.3l.94-4.6a.38.38,0,0,0-.18-.41l-4.86-2.87a.36.36,0,0,0-.44,0l-3.58,3a20.65,20.65,0,0,0-6.57-.93l-2.59-3.92a.38.38,0,0,0-.42-.16l-5.45,1.4a.38.38,0,0,0-.29.35l-.38,4.68a20.47,20.47,0,0,0-5.3,4L325,474.6a.38.38,0,0,0-.4.18l-2.87,4.86a.36.36,0,0,0,0,.44l3,3.58a20.65,20.65,0,0,0-.93,6.57L320,492.82a.38.38,0,0,0-.16.42l1.4,5.46a.4.4,0,0,0,.35.29l4.68.37a20.3,20.3,0,0,0,4,5.3l-.94,4.61a.4.4,0,0,0,.18.41l4.86,2.86a.38.38,0,0,0,.44,0l3.58-3.05a20.37,20.37,0,0,0,6.57.93l2.59,3.92a.38.38,0,0,0,.42.16l5.46-1.4a.37.37,0,0,0,.28-.34l.38-4.68a20.73,20.73,0,0,0,5.3-4l4.61.94a.4.4,0,0,0,.41-.18L367.2,500a.38.38,0,0,0,0-.44l-3.05-3.58a20.37,20.37,0,0,0,.93-6.57l3.92-2.59A.38.38,0,0,0,369.13,486.37Zm-19.59.66a5.8,5.8,0,0,1-2.31,7.85,5.86,5.86,0,0,1-2.76.7,5.78,5.78,0,1,1,5.07-8.55ZM348,503.83a14.35,14.35,0,0,1-17.51-10.34,14.75,14.75,0,0,1-.45-3.61,14.4,14.4,0,0,1,10.8-13.9l.76-.17h0a13.82,13.82,0,0,1,1.92-.25l.32,0,.07,1.55a13.14,13.14,0,0,0-2.71.4,12.75,12.75,0,0,0-7.57,5.45c-.09.14-.19.29-.27.44a12.72,12.72,0,0,0-1.79,6.51,12.56,12.56,0,0,0,.41,3.21,12.83,12.83,0,0,0,25.25-3.19,12.6,12.6,0,0,0-.41-3.2,12.75,12.75,0,0,0-3.4-5.92l1.09-1.11a14.35,14.35,0,0,1,3.81,6.65,14.18,14.18,0,0,1,.46,3.58A14.4,14.4,0,0,1,348,503.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M340.75,491.83a4.23,4.23,0,1,0,1.69-5.74A4.25,4.25,0,0,0,340.75,491.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M642.4,241.68H522.92A41.49,41.49,0,0,0,487,262.42L427.25,365.89a41.47,41.47,0,0,0,0,41.5L487,510.86a41.49,41.49,0,0,0,35.93,20.74H642.4a41.5,41.5,0,0,0,35.93-20.74l59.74-103.47a41.52,41.52,0,0,0,0-41.5L678.33,262.42A41.5,41.5,0,0,0,642.4,241.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M522.92,511.74a21.69,21.69,0,0,1-18.74-10.81L444.44,397.46a21.72,21.72,0,0,1,0-21.64l59.74-103.47a21.69,21.69,0,0,1,18.74-10.81H642.4a21.69,21.69,0,0,1,18.73,10.81l59.74,103.47a21.72,21.72,0,0,1,0,21.64L661.13,500.93a21.69,21.69,0,0,1-18.73,10.81Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 582.31,
    cy: 383.16,
    r: 73.16,
    transform: "translate(122.08 906.69) rotate(-82.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M582.3,444.69a61.53,61.53,0,0,1,0-123.06,9.88,9.88,0,1,1,0,19.75,41.78,41.78,0,1,0,41.79,41.78,9.87,9.87,0,1,1,19.74,0A61.6,61.6,0,0,1,582.3,444.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225,725.37H105.54a41.49,41.49,0,0,0-35.93,20.75L9.87,849.59a41.5,41.5,0,0,0,0,41.49L69.61,994.55a41.48,41.48,0,0,0,35.93,20.74H225A41.48,41.48,0,0,0,261,994.55l59.74-103.47a41.5,41.5,0,0,0,0-41.49L261,746.12A41.49,41.49,0,0,0,225,725.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105.54,995.44a21.7,21.7,0,0,1-18.73-10.82L27.07,881.15a21.7,21.7,0,0,1,0-21.63L86.81,756a21.69,21.69,0,0,1,18.73-10.81H225A21.69,21.69,0,0,1,243.75,756l59.74,103.48a21.65,21.65,0,0,1,0,21.63L243.75,984.62A21.7,21.7,0,0,1,225,995.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M200.63,828.86c0,19.52-15.82,40.58-35.33,40.58S130,848.38,130,828.86s15.81-33.35,35.33-33.35S200.63,809.35,200.63,828.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M121.45,944.57H207.7a20.89,20.89,0,0,0,19.89-14.52l4.64-14.5a20.87,20.87,0,0,0-12.6-25.95c-35.1-12.84-71.4-11.19-108.58,1.18A20.78,20.78,0,0,0,97.73,916l3.57,13.18A20.89,20.89,0,0,0,121.45,944.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1408.47,698.07,1619,294.71h-43.13a9.42,9.42,0,0,1-7.29-15.39L1793,5.83c9.72-11.86,28.93-4.34,28,11l-15.77,267.44a26.72,26.72,0,0,1-29.72,25l-30.07-3.44-208.9,452.4a33.27,33.27,0,0,1-30.2,19.32H1434Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1234.4,415.18,1383,745.36a54.51,54.51,0,0,0,49.7,32.13h76.63a28,28,0,0,0,24.46-14.41l2.73-4.91h0a21.91,21.91,0,0,1-19.51-11.95l-198-388Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1339,397.38h0a32.51,32.51,0,0,0-47.21,7.5L1073.26,733.22a94.38,94.38,0,0,1-78.58,42.1H963.93l-25-72.09s203.16-311.52,255.53-358.64c0,0,52.15-47,103.56-11.47a85.8,85.8,0,0,1,30.2,38.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M701.21,509.34s36.58-45.73,107.47-52.84c0,0,33.67,11.47,100.74,131.66s111.6,175,163.84,145.06l-4.32,7.18a78.78,78.78,0,0,1-67.49,38.14h-28.9c-31.81,0-59.44-49-78-74.83C842.33,631.14,733.28,520.6,701.21,509.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1795.7,102.57l-.37,0a3.29,3.29,0,0,1-2.9-3.64l1.48-13.06a3.29,3.29,0,1,1,6.54.74L1799,99.65A3.29,3.29,0,0,1,1795.7,102.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1608.38,267.41a3.3,3.3,0,0,1-2.6-5.3L1791.07,21.35a9,9,0,0,1,16,6.48l-3.27,28.86a3.29,3.29,0,0,1-6.54-.74l3.27-28.86a2.4,2.4,0,0,0-4.28-1.73L1611,266.12A3.25,3.25,0,0,1,1608.38,267.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1188,519.81a3.29,3.29,0,0,1-2.73-5.13l95.83-142a18.1,18.1,0,0,1,31.36,2.38,3.29,3.29,0,0,1-6,2.81,11.52,11.52,0,0,0-20-1.51l-95.83,142.05A3.28,3.28,0,0,1,1188,519.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1163.12,556.72a3.25,3.25,0,0,1-1.83-.56,3.29,3.29,0,0,1-.89-4.57l6.14-9.11a3.29,3.29,0,0,1,5.46,3.68l-6.15,9.11A3.28,3.28,0,0,1,1163.12,556.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1545.42,614.82c88.52,10.94,184.48,66.55,194.48,162.81,8.49,81.85-77.72,125.94-131.34,146.81A65.7,65.7,0,0,0,1574,955.62c-17.59,34.14-58.33,93.61-122,74.41a4.65,4.65,0,0,1,.55-9c15.15-2.77,36-9.72,47.33-27.1,15.45-23.67.8-55.43-27.08-60.08C1420,925,1316.76,892,1301.32,768,1280.44,600.26,1545.42,614.82,1545.42,614.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1524.92,756.91s-16.36-54-69-32.61c-49.88,20.22-17.38,87.38,65.75,116.1a29.33,29.33,0,0,0,26.72-3.93c29-20.82,94.88-76.62,41.53-121.57C1555.46,685.86,1524.92,756.91,1524.92,756.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1692.55,715.2a3.66,3.66,0,0,1-3.43-1.5c-44.36-61.78-121.39-76.62-178.2-78.19a3.67,3.67,0,0,1,.2-7.33c58.47,1.61,137.85,17,184,81.24a3.67,3.67,0,0,1-2.53,5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1721,785.62h-.16a3.66,3.66,0,0,1-3.94-3.37c0-.1-.83-10-5.48-24.45a3.67,3.67,0,1,1,7-2.25c4.94,15.33,5.78,25.7,5.81,26.14A3.67,3.67,0,0,1,1721,785.62Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmImg2);
export default __webpack_public_path__ + "static/media/crm_img_2.f6f743a901fd1402245db9d679935e38.svg";
export { ForwardRef as ReactComponent };